// @wc-ignore-file
import { safeRedirectPath } from "./post-auth-redirect";

/**
 * Search params shared by /login and /signup (and their check-email pages).
 * `redirect` is CR-288's return-to: dropped unless it is a same-origin
 * relative path.
 */
export type AuthSearch = { invite_code?: string; redirect?: string };

export function validateAuthSearch(search: Record<string, unknown>): AuthSearch {
  const result: AuthSearch = {};
  if (typeof search.invite_code === "string" && search.invite_code.length > 0) {
    result.invite_code = search.invite_code;
  }
  const redirect = safeRedirectPath(search.redirect);
  if (redirect) {
    result.redirect = redirect;
  }
  return result;
}

/**
 * Where an already signed-in visitor of /login or /signup goes: the invite
 * page wins over the return-to (CR-288 D2), then the default.
 */
export function guestRedirectFor(search: AuthSearch): string | undefined {
  if (search.invite_code) {
    return `/invite/${encodeURIComponent(search.invite_code)}`;
  }
  return safeRedirectPath(search.redirect);
}
